module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_tablet_de-33cfa1d87b62c0be5e7916732a400be1.png";